module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "untitled-1"
    }
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal-310-0-override4"
  }, [_c('span', {
    staticClass: "no-style-override17"
  }, [_c('br', {
    staticClass: "calibre1"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "extended-quotes-311-0-override"
  }, [_c('span', {
    staticClass: "no-style-override18"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "extended-quotes-311-0-override"
  }, [_c('span', {
    staticClass: "no-style-override18"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "extended-quotes-311-0-override"
  }, [_c('span', {
    staticClass: "no-style-override18"
  }, [_vm._v("‘Those who look only to the past or present are certain to miss the future.’")])]), _vm._v(" "), _c('p', {
    staticClass: "extended-quotes-311-0-override"
  }, [_c('span', {
    staticClass: "no-style-override18"
  }, [_vm._v("‘Forgive your enemies, but never forget their names.’")])]), _vm._v(" "), _c('p', {
    staticClass: "extended-quotes-311-0-override"
  }, [_c('span', {
    staticClass: "no-style-override19"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "extended-quotes-311-0-override"
  }, [_c('span', {
    staticClass: "no-style-override19"
  }, [_vm._v("– John Fitzgerald Kennedy")])]), _vm._v(" "), _c('p', {
    staticClass: "extended-quotes-311-0-override"
  }, [_c('span', {
    staticClass: "no-style-override19"
  }, [_vm._v("35")]), _c('span', {
    staticClass: "no-style-override20"
  }, [_vm._v("th")]), _c('span', {
    staticClass: "no-style-override19"
  }, [_vm._v(" U.S. president")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override5"
  }, [_c('span', {
    staticClass: "no-style-override21"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "calibre_pb_18"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1baad0b1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Quote.vue
// module id = 78
// module chunks = 0